import styled from 'styled-components';

const UploadFileMLStyled = styled.div`
  .text {
    margin-left: 8px;
    color: ${(props) => (props.status === 'detail' ? '#d3d3d3' : '')};
  }
  .button-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }
  .MuiFab-root {
    background-color: ${(props) =>
      props.status === 'detail' ? '#d3d3d3' : ''};
    width: 80px;
    color: #fff;
    .MuiSvgIcon-root {
      margin-right: 8px;
    }
  }
  .defaultImage {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .disabled {
    background-color: #d3d3d3;
    cursor: no-drop;
  }
  .input {
    display: none;
  }
  .file-name {
    width: 550px;
    margin-top: 16px;
    .row {
      height: 48px;
      display: flex;
      font-size: 14px;
      color: #212121;
      align-items: center;
      background: #f5f5f5;
      .name {
        width: 230px;
        text-align: center;
      }
      .font {
        width: 90px;
        text-align: center;
      }
      .action {
        width: 230px;
        text-align: center;
      }
    }
    .second-row {
      background: #fff;
      .delete {
        width: 230px;
        display: flex;
        justify-content: center;
        text-align: center;
      }
    }
  }
`;

export default UploadFileMLStyled;
